import noContent from './no-content.vue';

export default noContent;
